export enum DisconnectdSaleStep {
    IDENTIFICATION = 'identification',
    PAYMENT = 'payment',
    SUCCESS = 'success'
}